import React, {Fragment} from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import BlogList from '../../components/BlogList/BlogList'
import NavbarS2 from '../../components/NavbarS2/NavbarS2';
import FooterS2 from '../../components/footerS2/FooterS2';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.png'
import bg from '../../images/gallery/SSK_0082.png';

const BlogPage =() => {
    return(
        <Fragment>
            <NavbarS2 hclass={'wpo-site-header'} Logo={Logo} />
            <PageTitle pageTitle={'Gallery'} pagesub={'Blog'} bg={bg}/> 
            <BlogList/>
            <FooterS2/>
            <Scrollbar/>
        </Fragment>
    )
};
export default BlogPage;

